import React, { useEffect, useState } from 'react';
import { Table, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const AddTypes = () => {
    const [types, setTypes] = useState([]);
    const [title, setTitle] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedType, setSelectedType] = useState(null);

    // Fetch all types on component mount
    useEffect(() => {
        fetchTypes();
    }, []);

    const fetchTypes = async () => {
        try {
            const response = await axios.get('https://drdprints.com/api/get-types');
            setTypes(response.data.types);
        } catch (error) {
            console.error('Error fetching types:', error);
        }
    };

    // Add new type
    const handleAddType = async (e) => {
        e.preventDefault();
        try {
            const newType = { title };
            await axios.post('https://drdprints.com/api/store-types', newType);
            setTitle('');
            fetchTypes();
        } catch (error) {
            console.error('Error adding type:', error);
        }
    };

    // Open modal for updating type
    const handleOpenUpdateModal = (type) => {
        setSelectedType(type);
        setTitle(type.title);
        setShowModal(true);
    };

    // Update type
    const handleUpdateType = async () => {
        try {
            const updatedType = { title };
            await axios.put(`https://drdprints.com/api/update-types/${selectedType.id}`, updatedType);
            setShowModal(false);
            setSelectedType(null);
            fetchTypes();
        } catch (error) {
            console.error('Error updating type:', error);
        }
    };

    // Delete type
    const handleDeleteType = async (id) => {
        try {
            await axios.delete(`https://drdprints.com/api/deletetypes/${id}`);
            fetchTypes();
        } catch (error) {
            console.error('Error deleting type:', error);
        }
    };

    return (
        <div className="container mt-5">
            <h1>Manage Types</h1>

            {/* Form to Add New Type */}
            <Form onSubmit={handleAddType}>
                <Form.Group controlId="formTitle">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter type title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </Form.Group>
                <Button variant="primary" className="mt-2" type="submit">
                    Add Type
                </Button>
            </Form>

            {/* Display Types */}
            <h2 className="mt-5">Available Types</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {types.map((type) => (
                        <tr key={type.id}>
                            <td>{type.id}</td>
                            <td>{type.title}</td>
                            <td>{new Date(type.created_at).toLocaleDateString()}</td>
                            <td>{new Date(type.updated_at).toLocaleDateString()}</td>
                            <td>
                                <Button
                                    variant="warning"
                                    onClick={() => handleOpenUpdateModal(type)}
                                >
                                    Edit
                                </Button>{' '}
                                <Button
                                    variant="danger"
                                    onClick={() => handleDeleteType(type.id)}
                                >
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal for updating type */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter type title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleUpdateType}>
                        Update Type
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddTypes;
